import { Provider } from "./provider/Provider";

const WidgetService = {
  widgets: () => {
    return Provider({
      methodName: "Api/Widget/Widgets"
    });
  },
  widget: ({ widgetListSysName, lang }) => {
    return Provider({
      widgetListSysName,
      lang,
      methodName: "Api/Widget/Widget"
    });
  },
  systemTree: () => {
    return Provider({
      methodName: "Api/Widget/SystemTree"
    });
  },
  allWidgetList: ({ lang }) => {
    return Provider({
      lang,
      methodName: "Api/Widget/AllWidgetList"
    });
  },
  getWidgetList: ({ widgetListCode }) => {
    return Provider({
      widgetListCode,
      methodName: "Api/Widget/getWidgetList_l"
    });
  },
  addWidget: ({ widgetName, widgetSysName, fields }) => {
    return Provider({
      widgetName: widgetName,
      widgetSysName: widgetSysName,
      widgetFields: fields,
      methodName: "Api/Widget/AddWidget"
    });
  },
  deleteWidgetList: widgetListSysName => {
    return Provider({
      widgetListSysName: widgetListSysName,
      methodName: "Api/Widget/DeleteWidgetList"
    });
  },
  addWidgetList: ({ widgetName, widgetSysName, _l }) => {
    return Provider({
      widgetListName: widgetName,
      widgetListSysName: widgetSysName,
      _l,
      methodName: "Api/Widget/AddWidgetList"
    });
  },
  editWidgetList: ({ widgetCode, widgetName, widgetSysName, _l }) => {
    return Provider({
      widgetListCode: widgetCode,
      widgetListName: widgetName,
      widgetListSysName: widgetSysName,
      _l,
      methodName: "Api/Widget/EditWidgetList"
    });
  },
  widgetDetail: () => {
    return Provider({
      methodName: "Api/Widget/WidgetDetail"
    });
  }
};

export default WidgetService;
